export default {
  bankDirectFlowList: {
    search: {
      accountName: '公司银行名称',
      tradeAmount: '交易金额范围',
      tradeDate: '交易日期',
      accountCode: '公司银行账号',
      toAccountName: '交易方名称',
      bankTradeSerial: '银行交易流水号',
      dcFlag: '交易方向',
      toAccountCode: '交易方银行账号',
      accountNamePlaceholder: '请选择公司银行名称',
      tradeAmountPlaceholder: '请输入交易金额范围',
      tradeDatePlaceholder: '请选择交易日期',
      accountCodePlaceholder: '请输入公司银行账号',
      toAccountNamePlaceholder: '请输入交易方名称',
      bankTradeSerialPlaceholder: '请输入银行交易流水号',
      dcFlagPlaceholder: '请选择交易方向',
      toAccountCodePlaceholder: '请输入交易方银行账号',
    },
    table: {
      companyName: '公司名称',
      accountName: '公司银行账户名称',
      accountCode: '公司银行账号',
      tradeAmount: '交易金额',
      dcFlag: '交易方向',
      tradeDate: '交易日期',
      toAccountName: '交易方名称',
      toBranchName: '交易方银行名称',
      toAccountCode: '交易方银行账号',
      bankTradeSerial: '银行交易流水号',
    },
    message: {},
  },
};
